import { useEffect, useState } from "react";

import { getCompanyPortalBankAccountInfo } from "../../../../../network/apis/companyPortalEvents";

/**
 * Yoram's bank details for the offline transfer; empty until they load.
 * `enabled` delays the request until the details are actually on screen.
 */
const useBankAccountInfo = (enabled = true) => {
  const [details, setDetails] = useState({});

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    getCompanyPortalBankAccountInfo()
      .then((response) => {
        if (!cancelled) setDetails(response?.data?.data ?? {});
      })
      // The interceptor reports the error; the card then shows empty rows.
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return details;
};

export default useBankAccountInfo;
